import React, { createContext, useContext } from 'react';
import {
  OnboardingProgressApi,
  useOnboardingProgress,
} from '../../hooks/useOnboardingProgress';

const OnboardingContext = createContext<OnboardingProgressApi | null>(null);

export const OnboardingProvider: React.FC<{
  organizationId: string | undefined;
  children: React.ReactNode;
}> = ({ organizationId, children }) => {
  const api = useOnboardingProgress(organizationId);
  return (
    <OnboardingContext.Provider value={api}>
      {children}
    </OnboardingContext.Provider>
  );
};

export function useOnboarding(): OnboardingProgressApi {
  const ctx = useContext(OnboardingContext);
  if (!ctx) {
    throw new Error('useOnboarding must be used within OnboardingProvider');
  }
  return ctx;
}

/** Safe when provider may be missing (e.g. tests). */
export function useOnboardingOptional(): OnboardingProgressApi | null {
  return useContext(OnboardingContext);
}
